export const getInitials = (firstName, lastName) => {
  if (firstName) {
    if (lastName) {
      const initials = `${firstName.charAt(0)}${lastName.charAt(0)}`;
      return initials.toUpperCase();
    }

    const initials = `${firstName.charAt(0)}${firstName.charAt(1)}`;
    return initials.toUpperCase();
  }
  return '';
};

const colors = [
  '#00AA55',
  '#009FD4',
  '#B381B3',
  '#939393',
  '#E3BC00',
  '#D47500',
  '#DC2A2A',
];

export const numberFromText = (text) => {
  // numberFromText("AA");
  const charCodes = text
    .split('') // => ["A", "A"]
    .map((char) => char.charCodeAt(0)) // => [65, 65]
    .join(''); // => "6565"
  return parseInt(charCodes, 10);
};

export const generateColor = (text = '') =>
  colors[numberFromText(text) % colors.length];

export const getSearchResult = (driverList, searchTerm) => {
  return driverList.filter((item) => {
    const lowerSearchTerm = searchTerm.toLowerCase();
    return (
      item.email.toLowerCase().includes(lowerSearchTerm) ||
      (item.firstName && item.firstName.toLowerCase().includes(lowerSearchTerm)) ||
      (item.lastName && item.lastName.toLowerCase().includes(lowerSearchTerm))
    );
  });
};
